module.exports = __webpack_public_path__ + "img/sld_scb_2_green.7966736e.svg";